import * as React from 'react';
import * as autoBind from 'react-autobind';
import {ControlButton, TscButtonType, Glyphs, TscThemeName} from '@techsmith/tsc-cloud-style-guide';
import Strings from '../../globals/Strings';
import MyWindow from '../../types/MyWindow';
import ImageCanvas from '../ImageCanvas/ImageCanvas';
import Constants from '../../globals/Constants';

declare const window: MyWindow;

export default class FullScreenImage extends React.Component<FullScreenImageProps, {}> {
   private overflowClass = 'fullscreen-image-overflow-hidden';

   constructor(props: FullScreenImageProps) {
      super(props);
      autoBind(this);
   }

   onKeyDown(e: KeyboardEvent) {
      if (e.keyCode === Constants.keys.escape) {
         this.props.onClose();
      }
   }

   componentWillMount() {
      window.document.getElementsByTagName('body')[0].classList.add(this.overflowClass);
      window.addEventListener('keydown', this.onKeyDown);
   }

   componentWillUnmount() {
      window.document.getElementsByTagName('body')[0].classList.remove(this.overflowClass);
      window.removeEventListener('keydown', this.onKeyDown);
   }

   render() {
      const {onClose, mediaUrl} = this.props;

      return (
         <div className="zoomed-image">
            <ControlButton title={Strings.labels.close} themeName={TscThemeName.dawn} buttonType={TscButtonType.secondary} glyph={<Glyphs.Close16x16 className="modal-close-glyph"/>} onClick={onClose}/>
            <ImageCanvas mediaUrl={mediaUrl} onDimensionsChange={() => null}/>
         </div>
      );
   }
}

export interface FullScreenImageProps {
   mediaUrl: string;
   onClose(): void;
}
